<template>
  <div class="el-collapse-item-content" :class="headerText === '子表：' ? 'maxheightNone' : ''">
    <div v-if="showHeader">
      <div class="customSubFormLabel" @mouseenter="handleMouseEnter">
        <el-tooltip :disabled="!enableTooltip" effect="dark" :content="headerText + businessName + tableName"
          placement="top-start">
          <div class="ellipsis-container">{{ headerText }} {{ businessName }} {{ tableName }}</div>
        </el-tooltip>
        <el-button v-if="isSubForm" size="mini" type="text" style="margin-left: 10px"
          @click="createTable">生成多行表格</el-button>
      </div>
    </div>

    <el-form ref="formRef" label-position="top" class="printDesignFormField">
      <draggable v-model="option.children" :options="{ group: groupName, handle: '.my-handle' }" class="dragArea"
        :move="dragMove" @end="dragEnd">
        <!-- 表单内容 -->
        <el-form-item v-for="(item, index) in option.children" :key="index">
          <template v-if="!item.children" slot="label">
            <div class="labelwrap" @mouseenter="handleMouseEnter($event, item)">
              <el-checkbox v-model="item.isSelected" style="margin-left: 10px" :true-label="1"
                :false-label="0"></el-checkbox>
              <el-tooltip :disabled="!item.enableTooltip" effect="dark"
                :content="item.name + item.label + (addTableName ? '(' + tableName + ')' : '')" placement="top-start">
                <div class="ellipsis-container label">{{ item.label }}（{{ item.name }}）</div>
              </el-tooltip>
            </div>
          </template>
          <div v-if="!item.children">
            <ul>
              <span class="desc">点击填入：</span>
              <li class="container-widget-item" :title="item.label" @click="handleCopyTille(item)">
                <span class="til">标题</span>
                <i class="el-icon-copy-document"></i>
              </li>
              <li class="container-widget-item" :title="item.label" @click="handleCopyVal(item)">
                <el-select v-model="item.valueType" placeholder="请选择" size="mini" class="marginRight5">
                  <el-option v-for="selectItem in grounpOptions" :key="selectItem.value" :label="selectItem.label"
                    :value="selectItem.value">
                    <template #default>
                      <span class="marginRight5">{{ selectItem.label }}</span>
                      <el-tooltip :content="selectItem.desc" placement="bottom" effect="dark">
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                  </el-option>
                </el-select>

                <i class="el-icon-copy-document"></i>
              </li>
              <li class="container-widget-item" :title="item.label" @click="handleCopyAll(item)">
                <span class="til">标题：字段</span>
                <i class="el-icon-copy-document"></i>
              </li>
              <i v-if="headerText === '子表：'" class="iconfont icon-drag drag-option my-handle"
                style="cursor: pointer; margin-right: 10px"></i>
              <!-- <el-tooltip content="同时复制属性和值" placement="bottom" effect="light">
              <i class="el-icon-question"></i>
            </el-tooltip> -->
            </ul>
          </div>
          <div v-else>
            <DesignPrintField :showHeader="true" headerText="子表：" :addTableName="true" :tableName="item.tableName"
              :businessName="item.businessName" :groupName="item.tableName + item.fieldNum" :option="item">
            </DesignPrintField>
          </div>
        </el-form-item>
      </draggable>
    </el-form>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "DesignPrintField",
  components: {
    draggable
  },
  props: {
    showHeader: Boolean,
    addTableName: Boolean,
    headerText: {
      type: String,
      default () {
        return "";
      }
    },
    option: {
      type: Object,
      default () {
        return {};
      }
    },
    tableName: {
      type: String,
      default () {
        return "";
      }
    },
    businessName: {
      type: String,
      default () {
        return "";
      }
    },
    groupName: {
      type: String,
      default () {
        return "";
      }
    }
  },
  data () {
    return {
      enableTooltip: null,
      grounpOptions: [
        {
          label: "普通值",
          value: 1,
          desc: "用于生成非多行表格"
        },
        {
          label: "表格头值",
          value: 2,
          desc: "用于生成多行表格，且应放在第一列"
        },
        {
          label: "表格中间值",
          value: 3,
          desc: "用于生成多行表格，且应放在中间列"
        },
        {
          label: "表格尾值",
          value: 4,
          desc: "用于生成多行表格，且应放在最后一列"
        }
      ]
    };
  },
  computed: {
    isSubForm () {
      return this.headerText === "子表：";
    }
  },
  mounted () { },
  methods: {
    getVal (item) {
      let val;
      switch (item.valueType) {
        case 1:
          val = `{{${item.name}}}`;
          break;
        case 2:
          val = `{{$fe:${this.isSubForm ? this.option.name : this.groupName} t.${item.name}`;
          break;
        case 3:
          val = `t.${item.name}`;
          break;
        case 4:
          val = `t.${item.name}}}`;
          break;
        default:
          break;
      }
      return val;
    },
    handleCopyVal (item) {
      console.log(item);
      const val = this.getVal(item);
      this.onCopy(val);
      item.isSelected = 1;
    },
    handleCopyTille (item) {
      console.log(item);
      this.onCopy(item.label);
    },
    handleCopyAll (item) {
      console.log(item);
      const val = this.getVal(item);
      this.onCopy(`${item.label}：${val}`);
      item.isSelected = 1;
    },
    dragEnd (e) {
      console.log(e);
    },
    dragMove (e) {
      console.log(e);
      return true;
    },
    getStyle (element, styleName) {
      if (!element || !styleName) return null;
      if (styleName === "float") {
        styleName = "cssFloat";
      }
      try {
        var computed = document.defaultView.getComputedStyle(element, "");
        return element.style[styleName] || computed ? computed[styleName] : null;
      } catch (e) {
        return element.style[styleName];
      }
    },
    handleMouseEnter (event, row) {
      if (row && typeof row.enableTooltip === "boolean") return;
      if (!row && typeof this.enableTooltip === "boolean") return;
      // 判断是否text-overflow, 如果是就显示tooltip
      const cellChild = event.target.querySelector(".ellipsis-container");
      const range = document.createRange();
      range.setStart(cellChild, 0);
      range.setEnd(cellChild, cellChild.childNodes.length);
      const rangeWidth = range.getBoundingClientRect().width;
      const padding = (parseInt(this.getStyle(cellChild, "paddingLeft"), 10) || 0) + (parseInt(this.getStyle(cellChild, "paddingRight"), 10) || 0);
      if (rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) {
        console.log("1");
        if (row) {
          this.$set(row, "enableTooltip", true);
        } else {
          this.enableTooltip = true;
        }
      } else {
        if (row) {
          this.$set(row, "enableTooltip", false);
        } else {
          this.enableTooltip = false;
        }
        console.log("2");
      }
    },

    getSelectedList () {
      return this.option.children.filter((item) => item.isSelected);
    },
    createTable () {
      const selectedList = this.getSelectedList();
      let length = selectedList.length;
      if (length) {
        selectedList.unshift({
          name: "_rn_",
          label: "序号"
        });
        length++;
        console.log(selectedList);
        const editor = document.querySelector("iframe").contentWindow.Asc.editor;
        editor.put_Table(length, 2);
        editor.pluginMethod_InputText(selectedList[0].label);
        for (let index = 0; index < length * 2 - 1; index++) {
          editor.onKeyDown(
            new KeyboardEvent("keydown", {
              key: "Tab ",
              keyCode: 9,
              code: "Tab"
            })
          );
          const isFirst = index + 1 - length === 0;
          const isLast = index === length * 2 - 2;
          const isLabel = index + 1 < length;
          const info = selectedList[isLabel ? index + 1 : index + 1 - length];
          let value;
          if (isLabel) {
            value = info.label;
          } else {
            value = `${isFirst ? "{{$fe:" + (this.isSubForm ? this.option.name : this.groupName) : ""} t.${info.name}${isLast ? "}}" : ""}`;
          }
          console.log(value);
          editor.pluginMethod_InputText(value);
        }
      } else {
        return this.$warn("请至少选中一个生成表格");
      }
    },

    onCopy (value) {
      console.log(value);
      try {
        document.querySelector("iframe").contentWindow.Asc.editor.pluginMethod_InputText(value + "");
      } catch (error) {
        console.error(error);
      }
      // const pasteText = editor.pluginMethod_PasteText;
      // pasteText(value + "");
      // this.$copyText(value + "").then(
      //   function (e) {
      //     console.log("copy arguments e:", e);
      //   },
      //   function (e) {
      //     console.error("copy arguments e:", e);
      //   }
      // );
    }
    // a() {
    //   const w = document.querySelector("iframe").contentWindow;
    //   w.AscCommon.g_clipboardBase._private_onpaste();
    //   watch w.AscCommon.g_clipboardBase.PasteFlag
    //   w.contentWindow.DE.Views.ImageSettings.prototype.onSelectWrap(undefined, {
    //     get() {
    //       return 2;
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
$valWidth: 80px;

.el-collapse-item-content {
  min-height: 10px;
  max-height: 500px;
  overflow: auto;

  .customSubFormLabel {
    font-size: 14px;
    margin-left: 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // height: 18px;
    // line-height: 34px;
  }

  .ellipsis-container {
    display: inline-block;
    width: 290px;
    /* 设置固定宽度 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    white-space: nowrap;
    /* 强制不换行 */
    text-overflow: ellipsis;
    /* 显示省略号 */
  }

  ul {
    padding-left: 10px;
    /* 重置IE11默认样式 */
    margin: 0;
    /* 重置IE11默认样式 */
    margin-block-start: 0;
    margin-block-end: 0.25em;
    padding-inline-start: 10px;
    display: flex;
    align-items: center;

    &:after {
      content: "";
      display: block;
      clear: both;
    }

    .container-widget-item {
      height: 30px;
      line-height: 30px;
      min-width: 60px;
      margin-right: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 0 8px;
      display: flex;
      justify-content: space-between;
      padding: 0 7px 0 10px;
      align-items: center;
    }

    .container-widget-item:hover {
      background: #f1f2f3;
      border-color: #409eff;

      .color-svg-icon {
        color: #409eff;
      }
    }

    .til {
      margin-right: 5px;
    }

    .til2 {
      width: $valWidth;
    }

    .drag-handler {
      position: absolute;
      top: 0;
      left: 160px;
      background-color: #dddddd;
      border-radius: 5px;
      padding-right: 5px;
      font-size: 11px;
      color: #666666;
    }
  }
}

.maxheightNone {
  max-height: none !important;
}

::v-deep .el-form-item__label {
  line-height: 16px;
}

.el-collapse-item ::v-deep ul>li {
  list-style: none;
}

::v-deep .el-form-item {
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
}

::v-deep .el-input__inner {
  border: none !important;
  padding-left: 0px;
  padding-right: 20px;
  width: $valWidth;
}

::v-deep .el-input__suffix {
  right: -3px;
}

.labelwrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.label {
  height: 16px;
  width: 330px !important;
  max-width: 330px !important;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
}

.marginRight5 {
  margin-right: 5px;
}
</style>
